import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import AreaPage from "@/pages/AreaPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import CityGuide from "@/pages/CityGuide";
import { initAnalytics } from "@/lib/analytics";

function App() {
  useEffect(() => { initAnalytics(); }, []);

  return (
    <div className="App font-body antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/yucaipa" element={<CityGuide slug="yucaipa" />} />
          <Route path="/highland" element={<CityGuide slug="highland" />} />
          <Route path="/loma-linda" element={<CityGuide slug="loma-linda" />} />
          <Route path="/calimesa" element={<CityGuide slug="calimesa" />} />
          <Route path="/:slug" element={<AreaPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
